<template>
    <div>
        <select v-model="val" class="form-control input-sm">
            <option value="">{{_traducao('global','escolha').toUpperCase()}}</option>
            <option v-for="(item, index) in estados" :key="index" :value="item.nome" v-if="valor == 'NOME'" >{{item.nome}}</option>
            <option v-for="(item, index) in estados" :key="index" :value="item.sigla" v-if="valor == 'SIGLA'" >{{item.nome}}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props: ['name', 'optionvalue', 'value'],
    

        data: function(){
            return {
                val: "",
                estados: [],
                valor: "SIGLA",
            }
        },

        mounted () {
            var self = this;

            if(!_.isNil(this.optionvalue)){
                this.valor = this.optionvalue
            }

            if(this.value != ""){
                this.val = this.value;
            }

            bus.$on('select-estado-limpa', function(name){
                if(self.name == name){
                    //console.log('limpa estado')
                    self.val == "";
                }
            });

            bus.$on('select-estado-seta', function(obj){
                if(self.name == obj.name){
                    self.val = obj.val;
                }
            });


            // estados
            this._providerEstado(function(lista){
                self.estados = lista
            })
        },

        watch: {
            val: function(val, oldVal){
                //console.log(val, oldVal)
                this.$emit("v-model", val);
            },
            value: function(val, oldVal){
                this.val = val
            }
        }
    }
</script>